import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { accessToken } from '../../../../configuration/tokenHandling/accessToken';
import { getMarketplaceBackend } from '../../config/pathURL/config';
import type { ServiceOverviewItem } from '../../customerCenter/serviceOverview/types';
import { decodeJson, onRejected } from '../api';
import { FetchError } from '../FetchError';
import { mapActivationSummaryResponse } from './activationSummaryMapper';
import { ApiActivationSummaryCodec } from './service.types';

export const activationSummaryApiSlice = createApi({
    reducerPath: 'activationSummaryApi',
    baseQuery: fetchBaseQuery({
        baseUrl: getMarketplaceBackend(),
        prepareHeaders: headers => {
            const token = accessToken.getAccessToken();
            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }
            return headers;
        },
    }),
    tagTypes: ['ActivationSummary'],
    endpoints: builder => ({
        getActivationSummary: builder.query<ServiceOverviewItem[], void>({
            query: () => '/activations/summary?embed=product',
            transformResponse: async (response: unknown) => {
                try {
                    const decoded = decodeJson(ApiActivationSummaryCodec)(response);
                    return mapActivationSummaryResponse(decoded);
                } catch (error) {
                    throw new FetchError({ ok: false, status: 500 } as Response, JSON.stringify(error));
                }
            },
            transformErrorResponse: (response: { status: number; data: unknown }) => {
                const error = new FetchError(
                    { ok: false, status: response.status } as Response,
                    JSON.stringify(response.data)
                );
                return onRejected([401, 403])(error);
            },
            providesTags: ['ActivationSummary'],
        }),
    }),
});

export const { useGetActivationSummaryQuery } = activationSummaryApiSlice;
